import * as React from 'react'

import AppContainer from '../../client/containers/appContainer'
import FeaturePageContainer from '../../client/containers/featurePageContainer'
import HomePageContainer from '../../client/containers/homePageContainer'
import LandingPageContainer from '../../client/containers/landingPageContainer'
import NotFoundPageContainer from '../../client/containers/notFoundPageContainer'
import SearchPageContainer from '../../client/containers/searchPageContainer'
import TopSellersPageContainer from '../../client/containers/topSellersPageContainer'
import RedirectPage from '../../client/pages/redirect'
import { redirectToItemPage } from '../../common/utils/location'
import { IRouteConfig, PageType } from '../../typings/routes'
import searchRoutes from './search'

export const newRoutes: IRouteConfig[] = [
  {
    component: AppContainer,
    path: '/',
    routes: [
      {
        component: HomePageContainer,
        exact: true,
        path: '/',
        pageType: PageType.HOME
      },
      {
        component: FeaturePageContainer,
        exact: true,
        path: '/feature',
        pageType: PageType.FEATURE
      },
      {
        component: TopSellersPageContainer,
        exact: true,
        path: '/top-sellers',
        pageType: PageType.POPULAR
      },
      {
        component: LandingPageContainer,
        path: '/free/:page',
        pageType: PageType.LANDING
      },
      ...searchRoutes,
      {
        component: NotFoundPageContainer,
        path: '/*',
        pageType: PageType.OTHER
      }
    ]
  }
]

export const oldRoutes: IRouteConfig[] = [
  {
    path: '/',
    component: AppContainer,
    routes: [
      {
        path: '/',
        exact: true,
        component: HomePageContainer,
        pageType: PageType.HOME
      },
      {
        component: FeaturePageContainer,
        path: '/feature',
        pageType: PageType.FEATURE
      },
      {
        component: TopSellersPageContainer,
        path: '/top-sellers',
        pageType: PageType.POPULAR
      },
      {
        component: SearchPageContainer,
        path: '/category/*',
        pageType: PageType.CATEGORY
      },
      {
        component: SearchPageContainer,
        path: '/tags/:tags',
        pageType: PageType.TAG
      },
      {
        component: SearchPageContainer,
        path: '/attributes/:key/:value',
        pageType: PageType.ATTRIBUTE
      },
      {
        component: ({ match }: any) => (
          <RedirectPage url={redirectToItemPage(match.params.term)} />
        ),
        path: '/search/:term(\\d{5,})',
        pageType: PageType.SEARCH
      },
      {
        component: SearchPageContainer,
        path: '/search',
        pageType: PageType.SEARCH
      },
      {
        path: '/free/:page',
        component: LandingPageContainer,
        pageType: PageType.LANDING
      },
      {
        path: '/*',
        component: NotFoundPageContainer,
        pageType: PageType.OTHER
      }
    ]
  }
]
